/** Bonni Brows: independently draggable comparisons, keyboard and theme editor friendly. */
(() => {
  function initCompare(slide) {
    if (slide.dataset.bonniReady === 'true') return;
    const slider = slide.querySelector('.bonni-compare__range');
    const canvas = slide.querySelector('.bonni-compare');
    if (!slider || !canvas) return;
    const update = () => {
      canvas.style.setProperty('--bonni-split', `${slider.value}%`);
      slider.setAttribute('aria-valuetext', `${slider.value}% after image revealed`);
    };
    slider.addEventListener('input', update);
    slider.addEventListener('change', update);
    update();
    slide.dataset.bonniReady = 'true';
  }
  function init(root = document) {
    if (root.matches?.('[data-bonni-pair]')) initCompare(root);
    root.querySelectorAll('[data-bonni-pair]').forEach(initCompare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
